export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13802.7cb9cf49.jpg";